// extracted by mini-css-extract-plugin
export default {"CountInfoBlock":"CountInfoBlock_CountInfoBlock__ah2LF","contNew":"CountInfoBlock_contNew__9NK9p"};